import {useTranslation} from 'react-i18next';
import {TShow} from '../../../../hooks/useShow';
import SheetShell from '../../components/SheetShell/SheetShell';
import {useSubscriptionList} from '../useSubscriptionList';
import MemberTicketRow from './MemberTicketRow';
import MemberListLoader from '../memberListLoader/MemberListLoader';
import MemberListError from '../memberListError/MemberListError';
import * as css from './MemberTicketsSheet.css';

interface MemberTicketsSheetProps {
    show: TShow;
    qid: number;
}

/* "My tickets" — the tickets bought with the subscription; each row links to the regular
   entrance ticket created for it */
function MemberTicketsSheet({show, qid}: MemberTicketsSheetProps) {
    const {t} = useTranslation('eTicket');
    const {items: tickets, isLoading, hasError, retry, onScroll} = useSubscriptionList('tickets', qid, show.isOpen);

    return (
        <SheetShell show={show} title={t('myTicketsTitle')} data-cy="member-tickets-sheet">
            {tickets?.length ? (
                <css.list onScroll={onScroll}>
                    {tickets.map(ticket => (
                        <MemberTicketRow key={ticket.qid} ticket={ticket} />
                    ))}
                    {isLoading && <MemberListLoader data-cy="member-tickets-loader" />}
                    {hasError && <MemberListError onRetry={retry} data-cy="member-tickets-error" />}
                </css.list>
            ) : isLoading ? (
                <MemberListLoader initial data-cy="member-tickets-loader" />
            ) : hasError ? (
                <MemberListError initial onRetry={retry} data-cy="member-tickets-error" />
            ) : (
                <css.empty>{t('noRedeemedTickets')}</css.empty>
            )}
        </SheetShell>
    );
}

export default MemberTicketsSheet;
